import React, { useEffect, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import moment from "moment";
import "daterangepicker/daterangepicker.css";
import "daterangepicker";
import $ from "jquery";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Enquiry = () => {
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [selectedUser, setSelectedUser] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
    // State for Follow-Up Modal
    const [isFollowUpModalOpen, setIsFollowUpModalOpen] = useState(false);
    const [followUpDate, setFollowUpDate] = useState(moment().format("YYYY-MM-DD"));
    const [followUpReason, setFollowUpReason] = useState("");
    const [followUpOptions, setFollowUpOptions] = useState([]);

    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
const [deleteDate, setDeleteDate] = useState(moment().format("YYYY-MM-DD"));
const [deleteReason, setDeleteReason] = useState("");

  useEffect(() => {
    fetchEnquiries();
  }, [startDate, endDate]);

  useEffect(() => {
    initializeDateRangePicker();
  }, []);


  useEffect(() => {
    fetchFollowUpReasons();
  }, []);

  const fetchFollowUpReasons = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/followup-reasons`);
      setFollowUpOptions(response.data);
    } catch (error) {
      console.error("Error fetching follow-up reasons:", error);
    }
  };

  const fetchEnquiries = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${API_BASE_URL}/enquiries`, {
        startDate,
        endDate,
      });
  
      const loggedInUser = localStorage.getItem("username"); // Retrieve logged-in username
  
      // Filter results based on allocatedUser
      const filteredEnquiries = response.data.filter(
        (enquiry) => enquiry.allocatedUser === loggedInUser
      );
  
      setEnquiries(filteredEnquiries); // Set only filtered data
    } catch (error) {
      console.error("Error fetching enquiries:", error);
    } finally {
      setLoading(false);
    }
  };
  

  const initializeDateRangePicker = () => {
    $("#enquiry_daterangepicker").daterangepicker(
      {
        startDate: moment(),
        endDate: moment(),
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")],
        },
      },
      (start, end) => {
        setStartDate(start.format("YYYY-MM-DD"));
        setEndDate(end.format("YYYY-MM-DD"));
        $("#enquiry_daterangepicker").html(`${start.format("MMMM D, YYYY")} - ${end.format("MMMM D, YYYY")}`);
      }
    );
    $("#enquiry_daterangepicker").html(`${moment().format("MMMM D, YYYY")} - ${moment().format("MMMM D, YYYY")}`);
  };

  const openModal = (user) => {
    setSelectedUser(user);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedUser(null);
  };


  const openDeleteModal = () => {
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setDeleteDate(moment().format("YYYY-MM-DD")); // Reset date
    setDeleteReason(""); // Reset reason
  };




  const updateEnquiryStatus = async (enquiryId, status) => {
    try {
      await axios.post(`${API_BASE_URL}/enquiry/update-status`, { enquiryId, status });
      alert(status === 2 ? "Enquiry moved to success!" : "Enquiry deleted!");
      
      // Refresh enquiries after update
      fetchEnquiries();
      closeModal();
    } catch (error) {
      console.error("Error updating status:", error);
      alert("Failed to update enquiry status.");
    }
  };

  // Open Follow-Up Modal
  const openFollowUpModal = () => {
    setIsFollowUpModalOpen(true);
  };

  // Close Follow-Up Modal
  const closeFollowUpModal = () => {
    setIsFollowUpModalOpen(false);
    setFollowUpDate(moment().format("YYYY-MM-DD")); // Reset date
    setFollowUpReason(""); // Reset reason
  };

  // Handle Follow-Up Save
  const handleSaveFollowUp = async () => {
    if (!followUpDate || !followUpReason) {
        alert("Please fill in all fields");
        return;
    }

    const loggedInUser = localStorage.getItem("username"); // Get logged-in user

    try {
      await axios.post(`${API_BASE_URL}/followup`, { 
        userId: selectedUser?.id,
            followUpDate,
            followUpReason,
            loggedInUser,
        });

        alert("Follow-up details saved successfully!");
        closeFollowUpModal();
        fetchEnquiries(); // Refresh data after follow-up is saved
    } catch (error) {
        console.error("Error saving follow-up:", error);
        alert("Failed to save follow-up details.");
    }
};

  
const handleSaveDelete = async () => {
  if (!deleteDate || !deleteReason) {
    alert("Please fill in all fields");
    return;
  }

  const loggedInUser = localStorage.getItem("username"); // Get logged-in user

  try {
    await axios.post(`${API_BASE_URL}/enquiry/delete`, {
      userId: selectedUser?.id,
      deleteDate,
      deleteReason,
      loggedInUser,
    });

    // Call updateEnquiryStatus to mark enquiry as deleted (status = 3)
    await updateEnquiryStatus(selectedUser.id, 3);

    alert("Enquiry deleted successfully!");
    closeDeleteModal();
    fetchEnquiries(); // Refresh data after delete is saved
  } catch (error) {
    console.error("Error deleting enquiry:", error);
    alert("Failed to delete enquiry.");
  }
};



  const columns = [
    { name: "SlNo", selector: (row) => row.slNo, sortable: true, width: "80px" }, // Reduced width
    {
      name: "Action",
      cell: (row) => (
        <button
          onClick={() => openModal(row)}
          className="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-700"
        >
          View
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "180px", // Reduced width
    },
    { name: "Allocated User", selector: (row) => row.allocatedUser, sortable: true, width: "200px" },
    { name: "Name", selector: (row) => row.name, sortable: true },
    { name: "Mobile No", selector: (row) => row.mobileno, sortable: true },
    { name: "Type", selector: (row) => row.type, sortable: true },
    { name: "AddDate", selector: (row) => row.addDate, sortable: true },
   
  ];

  return (
    <div className="container mx-auto">
      <h2 className="text-2xl font-bold mt-9 text-center">Enquiries</h2>
      
      <div className="flex justify-center items-center mt-9 mb-9">
  <div id="enquiry_daterangepicker" className="bg-white border px-4 py-2 inline-block rounded cursor-pointer">
    
    {`${moment().format("MMMM D, YYYY")} - ${moment().format("MMMM D, YYYY")}`}
    
  </div>
</div>
      {loading ? <p>Loading...</p> : <DataTable columns={columns} data={enquiries} pagination />}
      {modalIsOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-lg">
            {selectedUser && (
              <>
                <h2 className="text-2xl font-bold text-center text-blue-600 underline mb-4">User Details</h2>
                <div className="space-y-2">
                  <p><b>Name:</b> {selectedUser.name}</p>
                  <p><b>Mobile No:</b> <span className="bg-green-500 text-white px-2 py-1 rounded-md">{selectedUser.mobileno}</span></p>
                  <p><b>Gender:</b> {selectedUser.gender}</p>
                  <p><b>Type:</b> {selectedUser.type}</p>
                  <p><b>District:</b> {selectedUser.district}</p>
                  <p><b>City:</b> {selectedUser.city}</p>
                </div>

              <div className="mt-8 flex justify-between gap-2">
  <button 
    className="bg-green-500 text-white px-4 py-2 rounded w-full"
    onClick={() => updateEnquiryStatus(selectedUser.id, 2)}
  >
    Move to Success
  </button>
  <button 
    className="bg-red-500 text-white px-4 py-2 rounded w-full"
    // onClick={() => updateEnquiryStatus(selectedUser.id, 3)}
    onClick={openDeleteModal}

  >
    Delete
  </button>
  <button 
    className="bg-orange-500 text-white px-4 py-2 rounded w-full" 
    onClick={openFollowUpModal}
  >
    Follow-up
  </button>
  <button 
    className="bg-gray-400 text-white px-4 py-2 rounded w-full"
    onClick={closeModal}
  >
    Close
  </button>
</div>

              </>
            )}
          </div>
        </div>
      )}

{isDeleteModalOpen && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center p-4">
    <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-lg">
      <h3 className="text-xl font-bold mb-4 text-center text-red-700 underline">Delete Enquiry</h3>
      
      <div className="mb-4">
        <label htmlFor="deleteDate" className="block text-gray-700 font-medium mb-1">Delete Date:</label>
        <input
          id="deleteDate"
          type="date"
          value={deleteDate}
          onChange={(e) => setDeleteDate(e.target.value)}
          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-400"
        />
      </div>

      <div className="mb-4">
        <label htmlFor="deleteReason" className="block text-gray-700 font-medium mb-1">Delete Reason:</label>
        <input
          id="deleteReason"
          type="text"
          value={deleteReason}
          onChange={(e) => setDeleteReason(e.target.value)}
          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-400"
          placeholder="Enter delete reason"
        />
      </div>

      <div className="flex justify-between mt-4">
        <button
          onClick={handleSaveDelete}
          className="w-full bg-red-500 text-white font-medium py-2 rounded-md hover:bg-red-600 transition"
        >
          Delete
        </button>
        <button
          onClick={closeDeleteModal}
          className="w-full bg-gray-400 text-white font-medium py-2 rounded-md hover:bg-gray-500 transition ml-2"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
)}


{isFollowUpModalOpen && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center p-4">
    <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-lg">
      <h3 className="text-xl font-bold mb-4 text-center text-blue-700 underline">Follow Up</h3>
      
      <div className="mb-4">
        <label htmlFor="followUpDate" className="block text-gray-700 font-medium mb-1">Follow Up Date:</label>
        <input
          id="followUpDate"
          type="date"
          value={followUpDate}
          onChange={(e) => setFollowUpDate(e.target.value)}
          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
      </div>

        {/* Dropdown for Follow-Up Reason */}
        <div className="mb-4">
              <label className="block text-gray-700 font-medium mb-1">Follow Up Reason:</label>
              <select
    value={followUpReason}
    onChange={(e) => setFollowUpReason(e.target.value)}
    className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
>
    <option value="">Choose Any One</option>
    {followUpOptions.map((option) => (
        <option key={option.id} value={option.id}>
            {option.name}  {/* This displays the name, but we send the ID */}
        </option>
    ))}
</select>

            </div>

      <div className="flex justify-between mt-4">
        <button
          onClick={handleSaveFollowUp}
          className="w-full bg-green-500 text-white font-medium py-2 rounded-md hover:bg-green-600 transition"
        >
          Save
        </button>
        <button
          onClick={closeFollowUpModal}
          className="w-full bg-red-500 text-white font-medium py-2 rounded-md hover:bg-red-600 transition ml-2"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default Enquiry;
